"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1923],{

/***/ 97349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36822);






var Image = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var ratio = _param.ratio, _disabledEffect = _param.disabledEffect, disabledEffect = _disabledEffect === void 0 ? false : _disabledEffect, _effect = _param.effect, effect = _effect === void 0 ? "blur" : _effect, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "ratio",
        "disabledEffect",
        "effect",
        "sx"
    ]);
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        component: react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__.LazyLoadImage,
        wrapperClassName: "wrapper",
        effect: disabledEffect ? undefined : effect,
        placeholderSrc: disabledEffect ? "/assets/transparent.png" : "/assets/placeholder.svg",
        sx: {
            width: 1,
            height: 1,
            objectFit: "cover"
        }
    }, other));
    if (ratio) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            ref: ref,
            component: "span",
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                width: 1,
                lineHeight: 1,
                display: "block",
                overflow: "hidden",
                position: "relative",
                pt: getRatio(ratio),
                "& .wrapper": {
                    top: 0,
                    left: 0,
                    width: 1,
                    height: 1,
                    position: "absolute",
                    backgroundSize: "cover !important"
                }
            }, sx),
            children: content
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        ref: ref,
        component: "span",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            "& .wrapper": {
                width: 1,
                height: 1,
                backgroundSize: "cover !important"
            }
        }, sx),
        children: content
    });
});
function getRatio() {
    var ratio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1/1";
    return ({
        "4/3": "calc(100% / 4 * 3)",
        "3/4": "calc(100% / 3 * 4)",
        "6/4": "calc(100% / 6 * 4)",
        "4/6": "calc(100% / 4 * 6)",
        "16/9": "calc(100% / 16 * 9)",
        "9/16": "calc(100% / 9 * 16)",
        "21/9": "calc(100% / 21 * 9)",
        "9/21": "calc(100% / 9 * 21)",
        "1/1": "100%"
    })[ratio];
}
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 41923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ renderOptionFunc; },
/* harmony export */   "w": function() { return /* binding */ RichTextStyleWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7906);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53252);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53816);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50122);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29430);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97349);
/* harmony import */ var _theme_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78187);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22004);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  p {\n    font-size: inherit;\n    white-space: pre-line;\n  }\n\n  // List\n  & ul,\n  & ol {\n    padding-left: 1.25rem;\n    & li {\n      line-height: 2px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px 0px 0.75em;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 1.5;\n  font-size: 1.5em;\n  margin: 40px auto;\n  position: relative;\n  font-family: Georgia, serif;\n  padding: 3rem 3.5rem 3rem 4.5rem;\n  border-radius: 16px;\n  background-color: ",
        ";\n  color: ",
        " !important;\n  width: 100%;\n  display: block;\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p {\n    margin: 0 !important;\n  }\n\n  &:before {\n    left: 30px;\n    top: 10px;\n    display: block;\n    position: absolute;\n    font-size: 3em;\n    content: '\\201C';\n    position: absolute;\n    color: ",
        ";\n  }\n  @media (max-width: 768px) {\n    width: 100%;\n    padding: 1rem;\n  }\n"
    ], [
        "\n  line-height: 1.5;\n  font-size: 1.5em;\n  margin: 40px auto;\n  position: relative;\n  font-family: Georgia, serif;\n  padding: 3rem 3.5rem 3rem 4.5rem;\n  border-radius: 16px;\n  background-color: ",
        ";\n  color: ",
        " !important;\n  width: 100%;\n  display: block;\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p {\n    margin: 0 !important;\n  }\n\n  &:before {\n    left: 30px;\n    top: 10px;\n    display: block;\n    position: absolute;\n    font-size: 3em;\n    content: '\\\\201C';\n    position: absolute;\n    color: ",
        ";\n  }\n  @media (max-width: 768px) {\n    width: 100%;\n    padding: 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: scroll;\n  border-collapse: collapse;\n  width: 100%;\n  border: 1px solid ",
        ";\n  margin: 15px 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:hover {\n    background-color: ",
        ";\n    > td {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 150px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var ReactViewer = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return __webpack_require__.e(/* import() */ 1285).then(__webpack_require__.t.bind(__webpack_require__, 51285, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51285)
            ];
        }
    },
    ssr: false
});
var RichTextStyleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-13092476-0"
})(_templateObject());
var StyledImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_components_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-13092476-1"
})(_templateObject1());
var StyledBlockquote = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].blockquote.withConfig */ .ZP.blockquote.withConfig({
    componentId: "sc-13092476-2"
})(_templateObject2(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.background.neutral */ .ZP.light.background.neutral, _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.text.primary */ .ZP.light.text.primary, _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.text.disabled */ .ZP.light.text.disabled);
var StyledTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-13092476-3"
})(_templateObject3(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[500] */ .ZP.light.grey[500]);
var StyledTableCell = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-13092476-4"
})(_templateObject4(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[500] */ .ZP.light.grey[500]);
var StyledTableRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-13092476-5"
})(_templateObject5(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[200] */ .ZP.light.grey[200], _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[200] */ .ZP.light.grey[200]);
var TableHeadCell = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(StyledTableCell).withConfig({
    componentId: "sc-13092476-6"
})(_templateObject6(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[400] */ .ZP.light.grey[400]);
var isVideoFile = function(url) {
    var testUrl = url === null || url === void 0 ? void 0 : url.toLowerCase();
    if (testUrl === null || testUrl === void 0 ? void 0 : testUrl.includes("mp4")) return true;
    if (testUrl === null || testUrl === void 0 ? void 0 : testUrl.includes("mov")) return true;
    return false;
};
var ReactViewerComponent = function(props) {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    var asset = props.asset;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), displayImageSrc = ref[0], setDisplayImageSrc = ref[1];
    var _url;
    var isVideo = isVideoFile((_url = asset.url) !== null && _url !== void 0 ? _url : "");
    if (isVideo) {
        var _url1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            loop: true,
            width: "100%",
            height: "50vh",
            url: (_url1 = asset.url) !== null && _url1 !== void 0 ? _url1 : undefined,
            controls: true
        });
    }
    var _url2, _url3, _description, _url4;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImage, {
                onClick: function() {
                    return setDisplayImageSrc((_url2 = asset.url) !== null && _url2 !== void 0 ? _url2 : "");
                },
                src: (_url3 = asset.url) !== null && _url3 !== void 0 ? _url3 : "",
                alt: (_description = asset.description) !== null && _description !== void 0 ? _description : "",
                ratio: "16/9",
                sx: {
                    borderRadius: 1,
                    my: 5
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReactViewer, {
                zIndex: theme.zIndex.modal,
                showTotal: false,
                changeable: false,
                noNavbar: true,
                visible: !!displayImageSrc,
                onClose: function() {
                    return setDisplayImageSrc("");
                },
                onMaskClick: function() {
                    return setDisplayImageSrc("");
                },
                images: [
                    {
                        src: (_url4 = asset.url) !== null && _url4 !== void 0 ? _url4 : ""
                    }
                ]
            })
        ]
    });
};
var getYoutubeVideoID = function(url) {
    var match = url.match(/.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/);
    if (match !== null && match[1].length === 11) {
        return match[1];
    } else {
        return "";
    }
};
var renderOptionFunc = function(asset) {
    var _obj;
    return {
        renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var ref;
            var id = node.data.target.sys.id;
            var matchedAsset = asset === null || asset === void 0 ? void 0 : (ref = asset.block) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.sys.id) === id;
            });
            if (matchedAsset) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReactViewerComponent, {
                    asset: matchedAsset
                });
            }
            return null;
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_1, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h1",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_2, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h2",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_3, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h3",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_4, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h4",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_5, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h5",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_6, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h6",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.PARAGRAPH, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 1.5em"
                },
                variant: "body1",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTable, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_HEADER_CELL, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TableHeadCell, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_CELL, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTableCell, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_ROW, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTableRow, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.UL_LIST, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.OL_LIST, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ol", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.LIST_ITEM, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.QUOTE, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBlockquote, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HR, function() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                sx: {
                    my: 3
                }
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.HYPERLINK, function(node) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            if ((node === null || node === void 0 ? void 0 : (ref = node.data) === null || ref === void 0 ? void 0 : ref.uri.toLowerCase().indexOf(".png")) !== -1 || (node === null || node === void 0 ? void 0 : (ref1 = node.data) === null || ref1 === void 0 ? void 0 : ref1.uri.toLowerCase().indexOf(".jpg")) !== -1 || (node === null || node === void 0 ? void 0 : (ref2 = node.data) === null || ref2 === void 0 ? void 0 : ref2.uri.toLowerCase().indexOf(".jpeg")) !== -1 || (node === null || node === void 0 ? void 0 : (ref3 = node.data) === null || ref3 === void 0 ? void 0 : ref3.uri.toLowerCase().indexOf(".gif")) !== -1) {
                var ref8;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImage, {
                    src: node === null || node === void 0 ? void 0 : (ref8 = node.data) === null || ref8 === void 0 ? void 0 : ref8.uri
                });
            }
            if ((node === null || node === void 0 ? void 0 : (ref4 = node.data) === null || ref4 === void 0 ? void 0 : ref4.uri.indexOf("youtube.com/embed")) !== -1 || (node === null || node === void 0 ? void 0 : (ref5 = node.data) === null || ref5 === void 0 ? void 0 : ref5.uri.indexOf("youtube.com/watch")) !== -1) {
                var ref9;
                var videoId = getYoutubeVideoID(node === null || node === void 0 ? void 0 : (ref9 = node.data) === null || ref9 === void 0 ? void 0 : ref9.uri);
                var url = node.data.uri.indexOf("youtube.com/embed") !== -1 ? node.data.uri : "https://www.youtube.com/embed/".concat(videoId);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        position: "relative",
                        paddingTop: "56.25%"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                        width: "100%",
                        height: "100%",
                        src: url,
                        title: url,
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0
                        },
                        frameBorder: "0",
                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowFullScreen: true
                    })
                });
            }
            var domains = [
                "youtube.com/embed",
                "app.tango.us/app/embed"
            ];
            var isMatch = domains.some(function(domain) {
                var ref, ref1;
                return node === null || node === void 0 ? void 0 : (ref = node.data) === null || ref === void 0 ? void 0 : (ref1 = ref.uri) === null || ref1 === void 0 ? void 0 : ref1.includes(domain);
            });
            if (isMatch) {
                var ref10, ref11;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        position: "relative",
                        paddingTop: "56.25%"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                        width: "100%",
                        height: "100%",
                        src: node === null || node === void 0 ? void 0 : (ref10 = node.data) === null || ref10 === void 0 ? void 0 : ref10.uri,
                        title: node === null || node === void 0 ? void 0 : (ref11 = node.data) === null || ref11 === void 0 ? void 0 : ref11.uri,
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0
                        },
                        frameBorder: "0",
                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowFullScreen: true
                    })
                });
            }
            if ((node === null || node === void 0 ? void 0 : (ref6 = node.data) === null || ref6 === void 0 ? void 0 : ref6.uri.indexOf("www.youtube.com/watch")) !== -1) {
                var ref12;
                var ref13;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        position: "relative",
                        paddingTop: "56.25%"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        width: "100%",
                        height: "100%",
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0
                        },
                        url: (ref13 = node === null || node === void 0 ? void 0 : (ref12 = node.data) === null || ref12 === void 0 ? void 0 : ref12.uri) !== null && ref13 !== void 0 ? ref13 : undefined,
                        controls: true
                    })
                });
            }
            if (node === null || node === void 0 ? void 0 : (ref7 = node.data) === null || ref7 === void 0 ? void 0 : ref7.uri.includes("https")) {
                var _content = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(node.content, 1), ref14 = _content[0], _value = ref14.value, value = _value === void 0 ? "Link" : _value;
                var _uri;
                var src = (_uri = node.data.uri) !== null && _uri !== void 0 ? _uri : "";
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    style: {
                        textDecoration: "underline"
                    },
                    target: "_blank",
                    rel: "noopener",
                    href: src,
                    children: value
                });
            }
        }), _obj)
    };
};


/***/ })

}]);